// extracted by mini-css-extract-plugin
module.exports = {"noCallBtn":"PsychPhoneVerification_noCallBtn__1-44X"};